import { Component, OnInit } from "@angular/core";
import { TranslateService } from "../../../../common/translate/translate.service";

import { SamlWizardService } from "../saml-wizard.service";
import { AbstractWizardStepComponent } from "../../../wizard-dialog/abstract-wizard-step.component";
import { SamlAttributesComponent } from "../saml-attributes/saml-attributes.component";

@Component({
	templateUrl: "./saml-summary.component.html"
})
export class SamlSummaryComponent extends AbstractWizardStepComponent<void> implements OnInit {
	public isDataSubmitted = false;

	constructor(
		private service: SamlWizardService,
		private translateService: TranslateService
	) {
		super();
	}

	public get idp() {
		return this.service.identityProvider;
	}

	public ngOnInit() { }

	public get title() {
		return "saml.wizard.summary.title";
	}

	public get description() {
		const action = this.translateService.translate(`sdp.label.${this.service.isCreate ? "create" : "update"}`);
		return this.translateService.translate("saml.wizard.summary.description", { action: action });
	}

	public get nextStep(): AbstractWizardStepComponent.ConstructorFunction<void> | undefined {
		return undefined;
	}

	public get previousStep() {
		return SamlAttributesComponent;
	}

	public get isFormValid() {
		return true;
	}

	public async performPrevious() { }

	public async performNext() {
		this.isDataSubmitted = true;
		try {
			await this.service.processSummary();
		} finally {
			this.isDataSubmitted = false;
		}
	}

	public get showProgressBar() {
		return this.isDataSubmitted;
	}
}
